import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { MailIcon, PhoneIcon, MapPinIcon, SendIcon } from 'lucide-react';
export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-863">
      <Navbar data-id="element-864" />
      <main className="flex-1" data-id="element-865">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-866">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-867">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-868">
              Contact Us
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-869">
              We're here to help. Get in touch with our team for support,
              inquiries, or feedback.
            </p>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-870">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-871">
            {/* Contact Info */}
            <div className="space-y-8" data-id="element-872">
              <div data-id="element-873">
                <h2 className="text-2xl font-bold text-text-dark mb-4" data-id="element-874">
                  Get in Touch
                </h2>
                <p className="text-text-muted leading-relaxed" data-id="element-875">
                  Whether you're a facility looking to fill shifts or a
                  healthcare professional seeking opportunities, our team is
                  ready to assist you.
                </p>
              </div>

              <div className="space-y-6" data-id="element-876">
                <div className="flex items-start gap-4" data-id="element-877">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-878">
                    <PhoneIcon className="w-6 h-6 text-medical-blue" data-id="element-879" />
                  </div>
                  <div data-id="element-880">
                    <h3 className="font-bold text-text-dark" data-id="element-881">Phone</h3>
                    <p className="text-text-muted mt-1" data-id="element-882">1-800-555-1234</p>
                    <p className="text-sm text-text-muted mt-1" data-id="element-883">
                      Available 24/7 for urgent staffing needs
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-884">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-885">
                    <MailIcon className="w-6 h-6 text-medical-blue" data-id="element-886" />
                  </div>
                  <div data-id="element-887">
                    <h3 className="font-bold text-text-dark" data-id="element-888">Email</h3>
                    <p className="text-text-muted mt-1" data-id="element-889">
                      support@carenomad.com
                    </p>
                    <p className="text-sm text-text-muted mt-1" data-id="element-890">
                      We typically respond within 2 hours
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-891">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-892">
                    <MapPinIcon className="w-6 h-6 text-medical-blue" data-id="element-893" />
                  </div>
                  <div data-id="element-894">
                    <h3 className="font-bold text-text-dark" data-id="element-895">Headquarters</h3>
                    <p className="text-text-muted mt-1" data-id="element-896">
                      123 Healthcare Ave, Suite 400
                    </p>
                    <p className="text-text-muted" data-id="element-897">Toronto, ON M5V 3A8</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-float border border-gray-100 p-8" data-id="element-898">
              <h3 className="text-xl font-bold text-text-dark mb-6" data-id="element-899">
                Send us a message
              </h3>

              {submitted ? <div className="bg-soft-teal rounded-xl p-8 text-center" data-id="element-900">
                  <div className="w-16 h-16 bg-accent-teal rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-901">
                    <SendIcon className="w-8 h-8 text-white" data-id="element-902" />
                  </div>
                  <h4 className="text-xl font-bold text-text-dark mb-2" data-id="element-903">
                    Message Sent!
                  </h4>
                  <p className="text-text-muted" data-id="element-904">
                    Thank you for reaching out. A member of our team will get
                    back to you shortly.
                  </p>
                  <button onClick={() => setSubmitted(false)} className="mt-6 text-medical-blue font-semibold hover:underline" data-id="element-905">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-906">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-907">
                    <div data-id="element-908">
                      <label htmlFor="firstName" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-909">
                        First Name
                      </label>
                      <input type="text" id="firstName" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="Jane" data-id="element-910" />
                    </div>
                    <div data-id="element-911">
                      <label htmlFor="lastName" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-912">
                        Last Name
                      </label>
                      <input type="text" id="lastName" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="Doe" data-id="element-913" />
                    </div>
                  </div>

                  <div data-id="element-914">
                    <label htmlFor="email" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-915">
                      Email Address
                    </label>
                    <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="jane@example.com" data-id="element-916" />
                  </div>

                  <div data-id="element-917">
                    <label htmlFor="subject" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-918">
                      Subject
                    </label>
                    <select id="subject" className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors bg-white" data-id="element-919">
                      <option data-id="element-920">I'm a facility looking for staff</option>
                      <option data-id="element-921">
                        I'm a healthcare worker looking for shifts
                      </option>
                      <option data-id="element-922">General Inquiry</option>
                      <option data-id="element-923">Support</option>
                    </select>
                  </div>

                  <div data-id="element-924">
                    <label htmlFor="message" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-925">
                      Message
                    </label>
                    <textarea id="message" rows={4} required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors resize-none" placeholder="How can we help you?" data-id="element-926"></textarea>
                  </div>

                  <button type="submit" className="w-full bg-medical-blue hover:bg-medical-blue-dark text-white font-bold py-3.5 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-927">
                    <SendIcon className="w-4 h-4" data-id="element-928" />
                    Send Message
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </main>
      <StickyFooter data-id="element-929" />
    </div>;
}